import { InlineNotification, Modal } from '@carbon/react';
import { useAtom } from 'jotai';
import { formatMutationResource } from 'utils/misc';
import { enableAutoUpdateAtom } from '../atoms';
import styles from './auto-update-modal.module.scss';

interface DisableAutoUpdateModalProps {
  isOpen: boolean;
  collectionId: string;
  collectionName: string;
  onClose: () => void;
  onConfirm: () => void;
}

export const DisableAutoUpdateModal = ({
  isOpen,
  collectionId,
  collectionName,
  onClose,
  onConfirm,
}: DisableAutoUpdateModalProps) => {
  const [enableAutoUpdateState, enableAutoUpdate] =
    useAtom(enableAutoUpdateAtom);
  const { loading: isSubmitting } = formatMutationResource(
    enableAutoUpdateState
  );
  const hasSubmitError =
    enableAutoUpdateState.result?.type === 'error' ||
    enableAutoUpdateState.result?.type === 'fatal';

  const handleConfirm = () => {
    enableAutoUpdate({
      url: `/structure_grid_collections/${collectionId}`,
      type: 'PATCH',
      data: { landingAutoUpdateEnabled: false },
      onSuccess: onConfirm,
    });
  };

  return (
    <Modal
      open={isOpen}
      modalLabel={collectionName}
      modalHeading="Disable Auto-Update"
      primaryButtonText={isSubmitting ? 'Disabling...' : 'Confirm'}
      primaryButtonDisabled={isSubmitting}
      secondaryButtonText="Cancel"
      onRequestSubmit={handleConfirm}
      onRequestClose={isSubmitting ? undefined : onClose}
      className={styles.modal}
    >
      {hasSubmitError && (
        <InlineNotification
          kind="error"
          title="Failed to disable Auto Update."
          subtitle="Please try again."
          hideCloseButton
          lowContrast
        />
      )}

      <p className={styles.description}>
        Auto Update will be disabled. Landing analysis will no longer run
        automatically for wells in this Collection.
      </p>
    </Modal>
  );
};
